import { useState, useEffect } from "react";
import { Container, Grid } from "@material-ui/core";
import HeaderClientes from "components/_refactor/headers/clients.js";
import FilterCard from "components/_refactor/filter-card";
import InputText from "components/_refactor/text/input";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import Api from "lib/api/httpRequestHelper";
import TableSellers from "./components/table-sellers";
import DialogSeller from "./components/dialog-seller";

const situacaoOptions = [
  { value: "true", label: "Ativo" },
  { value: "false", label: "Inativo" },
];

const PAGE_SIZE = 500;

export default function Sellers() {
  const snackbar = useSnackbar();

  const [searching, setSearching] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [sellerToEdit, setSellerToEdit] = useState(null);
  const [sellers, setSellers] = useState([]);
  const [filter, setFilter] = useState({
    search: "",
    situacao: null,
  });

  const handleSearch = async () => {
    setSearching(true);
    try {
      const params = new URLSearchParams();

      if (filter.search?.trim()) params.append("search", filter.search.trim());
      if (filter.situacao?.value) params.append("isActive", filter.situacao.value);

      params.append("page", "0");
      params.append("pageSize", PAGE_SIZE.toString());

      const response = await Api.get(
        "list-sellers",
        "order",
        `?${params.toString()}`,
        true
      );

      if (response?.Success === false && response?.ValidationMessage) {
        snackbar.showMessage(response.ValidationMessage, { severity: "warning" });
        setSellers([]);
        return;
      }

      setSellers(response?.Result?.Sellers || []);
    } catch (error) {
      snackbar.showMessage(error?.toString() || "Erro ao buscar sellers.", {
        severity: "error",
      });
      setSellers([]);
    } finally {
      setSearching(false);
    }
  };

  useEffect(() => {
    handleSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInativarReativar = async (seller) => {
    try {
      const body = {
        id: seller.Id,
        sellerCode: seller.SellerCode,
        cnpj: seller.Cnpj || "",
        sellerName: seller.SellerName || "",
        idSeta: seller.IdSeta || "",
        idMarca: seller.IdMarca ?? "",
        idKarsten: seller.IdKarsten ?? "",
        isActive: !seller.IsActive,
        piNeomodePipelineAtivo: seller.PiNeomodePipelineAtivo,
      };

      const response = await Api.put("update-seller", "order", body, true);

      if (response?.Success === false && response?.ValidationMessage) {
        snackbar.showMessage(response.ValidationMessage, { severity: "error" });
        return;
      }

      snackbar.showMessage(
        seller.IsActive ? "Seller inativado com sucesso." : "Seller reativado com sucesso.",
        { severity: "success" }
      );
      handleSearch();
    } catch (error) {
      snackbar.showMessage(
        error?.toString() || "Erro ao alterar situação do seller.",
        { severity: "error" }
      );
    }
  };

  return (
    <>
      <HeaderClientes section="Sellers" subsection="Administração" />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <FilterCard
          handleSearch={handleSearch}
          disabled={searching}
          searching={searching}
        >
          <Grid item xs={12} lg={8}>
            <InputText
              label="Código, Nome ou CNPJ"
              value={filter.search}
              onChange={(e) => setFilter({ ...filter, search: e.target.value })}
              disabled={searching}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleSearch();
              }}
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <AutoCompleteField
              label="Situação"
              value={filter.situacao}
              onChange={(value) => setFilter({ ...filter, situacao: value })}
              options={situacaoOptions}
              optionLabelKey="label"
              optionIdKey="value"
              disabled={searching}
            />
          </Grid>
        </FilterCard>
        <TableSellers
          data={sellers}
          loading={searching}
          onAddSeller={() => {
            setSellerToEdit(null);
            setOpenDialog(true);
          }}
          onEdit={(row) => {
            setSellerToEdit(row);
            setOpenDialog(true);
          }}
          onInativarReativar={handleInativarReativar}
          onResearch={handleSearch}
        />
      </Container>
      <DialogSeller
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
          setSellerToEdit(null);
        }}
        onSaved={() => {
          setOpenDialog(false);
          setSellerToEdit(null);
          handleSearch();
        }}
        seller={sellerToEdit}
      />
    </>
  );
}
